import $ from 'jquery';
import Modernizr from 'modernizr';

let resized = false,
    resizeTimer = null,
    timeoutTime = 150,
    App = {};

function initResize() {
    setGlobalVars();
    $(window).on('resize', resizeProcessing);
    $(window).on('orientationchange', resizeProcessing);

    App.resize = resizeAfterProcessing.bind(this, true);
}

function setGlobalVars() {
    App.isTouch = Modernizr.touchevents;
    App.isWinPhone = !!('ontouchstart' in window || navigator.msMaxTouchPoints) && navigator.userAgent.match(/Windows Phone/i);
    App.isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    resizeAfterProcessing(true);
}

function resizeProcessing() {
    if (resizeTimer !== null) {
        clearTimeout(resizeTimer);
    }
    resized = true;
    resizeAfterProcessing();
}

function resizeAfterProcessing(notTrigger) {
    if (resized === true) {
        resized = false;
        resizeTimer = setTimeout(resizeAfterProcessing, timeoutTime);
        return;
    }

    var $window = $(window),
        width = $window.outerWidth(),
        height = $window.outerHeight();
    if (width == App.width && height == App.height) {
        return;
    }

    Object.assign(App, {
        width,
        height,
        orientation: typeof window.orientation === "undefined" || Math.abs(window.orientation) === 90 ? "landscape" : "portrait",
        isWidest: Modernizr.mq('only screen and (min-width:1500px)'),
        isDesktop: Modernizr.mq('only screen and (min-width:1025px)'),
        isTablet: Modernizr.mq('only screen and (min-width:769px)'),
        isPhoneLandscape: Modernizr.mq('only screen and (min-width:641px)')
    });

    if (typeof notTrigger != 'undefined' && notTrigger === true) {
        return;
    }

    $window.trigger('resize:finished');
}

initResize();

export default App;



// WEBPACK FOOTER //
// ./components/resizement/scripts/resize.js